import { makeStyles, DefaultTheme } from '@material-ui/styles';
import cn from 'clsx';

const Text: React.FC<TextProps> = props => {
    const {
        as: Component = 'span',
        variant = 't61',
        nowrap,
        clamp,
        children,
        className,
        style,
        ...domProps
    } = props;
    const classes = useStyles();
    const classNames = cn(
        classes.root,
        classes[variant],
        nowrap && classes.nowrap,
        clamp && classes.clamp,
        className
    );

    return (
        <Component
            style={{ WebkitLineClamp: clamp ? clamp : 'inherit', ...style }}
            className={classNames}
            {...domProps}
        >
            {children}
        </Component>
    );
};

const useStyles = makeStyles(
    theme => {
        return {
            root: {
                display: 'inline-block',
                maxWidth: '100%',
                color: 'inherit',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
            },
            t10: { ...theme.typography.t10 },
            t15: { ...theme.typography.t15 },
            t20: { ...theme.typography.t20 },
            t30: { ...theme.typography.t30 },
            t31: { ...theme.typography.t31 },
            t40: { ...theme.typography.t40 },
            t50: { ...theme.typography.t50 },
            t60: { ...theme.typography.t60 },
            t61: { ...theme.typography.t61 },
            t70: { ...theme.typography.t70 },
            t71: { ...theme.typography.t71 },
            t80: { ...theme.typography.t80 },
            t81: { ...theme.typography.t81 },
            t90: { ...theme.typography.t90 },
            nowrap: {
                whiteSpace: 'nowrap',
            },
            clamp: {
                display: '-webkit-box',
                '-webkit-box-orient': 'vertical',
            },
        };
    },
    { classNamePrefix: 'Text' }
);

type TextProps = {
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
    variant?: keyof DefaultTheme['typography'];
    nowrap?: boolean;
    clamp?: number | 'none' | 'inherit';
} & JSX.IntrinsicElements['p'];

export default Text;
